import { create } from 'zustand';
import { createSelectors } from './createSelectors';

export type UserMessageType = 'info' | 'error' | 'warning' | 'success';

interface MessageState {
  userMessage: string | null;
  messageType: UserMessageType;
  retainUserMessageOnApiCall: boolean;
  setUserMessage: (message: string, messageType: UserMessageType, retainOnApiCall?: boolean) => void;
  clearMessages: () => void;
  apiCallInProgress: boolean;
  setApiCallStarted: () => void;
  setApiCallCompleted: () => void;
}

const useUserMessageStoreBase = create<MessageState>((set, get) => ({
  userMessage: null,
  messageType: 'info',
  retainUserMessageOnApiCall: false,
  apiCallInProgress: false,
  setApiCallStarted: () => set({ userMessage: get().retainUserMessageOnApiCall ? get().userMessage : null, apiCallInProgress: true }),
  setApiCallCompleted: () => set({ apiCallInProgress: false }),
  setUserMessage: (message: string, messageType: UserMessageType, retainOnApiCall?: boolean): void =>
    set({ userMessage: message, messageType, retainUserMessageOnApiCall: retainOnApiCall ?? false }),
  clearMessages: () => set({ userMessage: null, retainUserMessageOnApiCall: false }),
}));

export const useUserMessageStore = createSelectors(useUserMessageStoreBase);
